/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    declare type VuMeterDirectiveFactoryCb = ($timeout: ng.ITimeoutService) => VuMeterDirective;

    export interface IVuMeterDirectiveScopeDef {
        audioStatus: string;
        lLevel: string;
        rLevel: string;
        transparent: string;
    }

    export interface IVuMeterDirectiveScope extends ng.IScope {
        audioStatus: boolean;
        lLevel: number;
        rLevel: number;
        transparent: boolean;

        lPrevLevel: number;
        numberOfChunksToFillL: number;
        numberOfChunksToFillPrevL: number;
        rPrevLevel: number;
        numberOfChunksToFillR: number;
        numberOfChunksToFillPrevR: number;

        totalChunks: number;
        range: (max: number) => number[];
        getChunkColor: (chunk: number, side: 'left' | 'right') => Object;
        getStatusColor: () => Object;
    }

    interface IVuMeterChunks {
        numberOfChunksToFill: number;
        numberOfChunksToFillPrev: number;
    }

    /**
     * Bar directive
     */
    export class VuMeterDirective implements ng.IDirective {
        public static $name: string = "vuMeter";

        public link: (scope: IVuMeterDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'E';
        public transclude: boolean = false;
        public replace: boolean = true;
        public templateUrl: string = 'decorators/vu-meter-directive.html';
        public scope: IVuMeterDirectiveScopeDef = {
            audioStatus: '=',
            lLevel: '=',
            rLevel: '=',
            transparent: '=',
        };

        /**
         * Factory for the directive
         */
        public static Factory(): VuMeterDirectiveFactoryCb {
            let directive: VuMeterDirectiveFactoryCb = ($timeout: ng.ITimeoutService) => {
                return new VuMeterDirective($timeout);
            };
            directive.$inject = ['$timeout'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor(private $timeout: ng.ITimeoutService) {
            VuMeterDirective.prototype.link = ($scope: IVuMeterDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                $scope.totalChunks = 30;

                this.updateLeftBar($scope, 0);
                this.updateRightBar($scope, 0);
                $scope.$watch('lLevel', (newVal: number, oldVal: number) => {
                    if (newVal !== oldVal && newVal !== undefined) {
                        this.updateLeftBar($scope, oldVal);
                    }
                });

                $scope.$watch('rLevel', (newVal: number, oldVal: number) => {
                    if (newVal !== oldVal && newVal !== undefined) {
                        this.updateRightBar($scope, oldVal);
                    }
                });

                $scope.range = (max: number): number[] => {
                    return Common.Utils.rangeForNgRepeat(max);
                };

                $scope.getChunkColor = (chunk: number, side: 'left' | 'right'): Object => {
                    let green: string = 'rgba(81, 255, 3, 1)';
                    let yellow: string = 'rgba(255, 254, 82, 1)';
                    let red: string = 'rgba(255, 0, 0, 1)';

                    let color: string;
                    if (chunk < 4) {
                        color = red;
                    // } else if (chunk === 3) {
                    //     color = `linear-gradient(${red}, ${yellow})`;
                    } else if (chunk < 10) {
                        color = yellow;
                    // } else if (chunk === 9) {
                    //     color = `linear-gradient(${yellow}, ${green})`;
                    } else {
                        color = green;
                    }

                    let numberOfChunksToFill: number = side === 'left' ? $scope.numberOfChunksToFillL : $scope.numberOfChunksToFillR;
                    let numberOfChunksToFillPrev: number = side === 'left' ? $scope.numberOfChunksToFillPrevL :
                                                                             $scope.numberOfChunksToFillPrevR;
                    let opacity: string;
                    if (!$scope.audioStatus) {
                        opacity = '.1';
                    } else if ($scope.totalChunks - chunk <= numberOfChunksToFill) {
                        opacity = '1';
                    } else if ($scope.totalChunks - chunk <= numberOfChunksToFillPrev) {
                        opacity =  '.3';
                    } else {
                        opacity = '.1';
                    }

                    return {
                        'background': color,
                        'opacity': opacity,
                    };
                };

                $scope.getStatusColor = (): Object => {
                    return {
                        'background': $scope.audioStatus ? 'rgba(81, 255, 3, 1)' : 'rgba(255, 0, 0, 1)',
                    };
                };
            };
        };

        private updateRightBar($scope: Application.Directives.IVuMeterDirectiveScope, oldVal: number): void {
            $scope.rPrevLevel = oldVal ? oldVal : 0;
            let chunks: IVuMeterChunks = this.calculateChunksToFill('right', $scope);
            $scope.numberOfChunksToFillR = chunks.numberOfChunksToFill;
            $scope.numberOfChunksToFillPrevR = chunks.numberOfChunksToFillPrev;
        }

        private updateLeftBar($scope: Application.Directives.IVuMeterDirectiveScope, oldVal: number): void {
            $scope.lPrevLevel = oldVal ? oldVal : 0;
            let chunks: IVuMeterChunks = this.calculateChunksToFill('left', $scope);
            $scope.numberOfChunksToFillL = chunks.numberOfChunksToFill;
            $scope.numberOfChunksToFillPrevL = chunks.numberOfChunksToFillPrev;
        }

        private calculateChunksToFill(side: "left" | "right", $scope: Application.Directives.IVuMeterDirectiveScope): IVuMeterChunks {
            let level: number = (side === 'left') ? $scope.lLevel : $scope.rLevel;
            let prevLevel: number = (side === 'left') ? $scope.lPrevLevel : $scope.rPrevLevel;
            let EPIC: number = this.fx(level);
            let numberOfChunksToFill: number = $scope.totalChunks - Math.floor(EPIC);
            // console.log(`Level ${level} translated to EPIC ${EPIC} numberOfChunksToFill = ${numberOfChunksToFill}`);
            // let numberOfChunksToFill: number = Math.ceil($scope.totalChunks * (level / 100.0));
            let epicPrev: number = this.fx(prevLevel);
            let numberOfChunksToFillPrev: number = $scope.totalChunks - Math.floor(epicPrev);
            return {numberOfChunksToFill, numberOfChunksToFillPrev};
        }

        private fx(level: number): number {
            if (level < 0 ) level = 0;
            if (level > 100) level = 100;
            const epicLevels: number[] = [
                29, 29, 28, 27, 26, 25, 24, 23, 22, 21, // 0 - 9
                20, 19, 18, 17, 17, 16, 16, 15, 15, 15, // 10-19
                15, 14, 13, 13, 13, 12, 12, 12, 11, 11, // 20-29
                11, 10, 10, 10, 10,  9,  9,  9,  9,  9, // 30-39
                 8,  8,  8,  8,  8,  7,  7,  7,  6,  6, // 40-49
                 6,  6,  6,  6,  6,  5,  5,  5,  5,  5, // 50-59
                 5,  5,  5,  4,  4,  4,  4,  4,  4,  4, // 60-69
                 3,  3,  3,  3,  3,  3,  3,  3,  3,  3, // 70-79
                 2,  2,  2,  2,  2,  2,  2,  2,  2,  2, // 80-89
                 1,  1,  1,  1,  1,  1,  1,  1,  1,  1, // 90-99
                 0,
            ];
            return epicLevels[level];
            // This would using the formula (ant then it should be rounded floored or ceiled (no f*ing idea which to use)
            // return -0.00007 * Math.pow(level, 3) + 0.0126 * Math.pow(level, 2) - 0.8933 * level + 30;
        }
    }
}
